import type { HeaderMenusConfig } from '../../headerMenus.types.ts';
import { ROUTES } from './routes/routes.ts';

const navigationLinks: HeaderMenusConfig['navigationLinks'] = [
  {
    href: ROUTES.NAVIGATION.LIVE_DRAW,
    text: 'live_draw',
    trackName: 'Live Draw',
  },
  {
    href: ROUTES.NAVIGATION.PLAY,
    text: 'play',
    trackName: 'Play',
  },
  {
    href: ROUTES.NAVIGATION.RESULTS,
    text: 'results',
    trackName: 'Results',
  },
  {
    href: ROUTES.NAVIGATION.PROMOTIONS,
    text: 'promotions',
    trackName: 'Promotions',
  },
];

const topMenuLinks: HeaderMenusConfig['topMenuLinks'] = [
  {
    href: ROUTES.NAVIGATION.LIVE_DRAW,
    labelKey: 'live_draw',
    trackName: 'Live Draw',
    icon: { name: 'ticketStar', size: 'medium' },
    showNotification: false,
  },
  {
    href: ROUTES.NAVIGATION.PLAY,
    labelKey: 'play',
    trackName: 'Play',
    icon: { name: 'ticketStar', size: 'medium' },
    showNotification: false,
  },
  {
    href: ROUTES.NAVIGATION.RESULTS,
    labelKey: 'results',
    trackName: 'Results',
    icon: { name: 'ticketStar', size: 'medium' },
    showNotification: false,
  },
  {
    href: ROUTES.NAVIGATION.PROMOTIONS,
    labelKey: 'promotions',
    trackName: 'Promotions',
    icon: { name: 'discountTag', size: 'small', className: 'text-accent-red' },
    showNotification: true,
  },
];

const bottomMenuLinks: HeaderMenusConfig['bottomMenuLinks'] = [
  {
    href: ROUTES.HELP_CENTRE.BASE_URL,
    labelKey: 'help_centre',
    trackName: 'Help Centre',
    icon: { name: 'help', size: 'medium' },
  },
  {
    href: ROUTES.NAVIGATION.MAGAZINE,
    labelKey: 'magazine',
    trackName: 'Magazine',
    icon: { name: 'fileBookmark', size: 'medium' },
  },
];

const headerMenus: HeaderMenusConfig = {
  bottomMenuLinks,
  navigationLinks,
  showsHamburgerMenuIcons: false,
  topMenuLinks,
};

export { headerMenus };
